'use client';

import { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { useSelector } from 'react-redux';
import { USER_MODE } from '../data/userModeConstants';

const LineContactButton = () => {
  const [open, setOpen] = useState(false);
  const user = useSelector(state => state.auth.user);

  if (user?.mode === USER_MODE.CUSTOMER) return;

  return (
    <Wrapper>
      {/* ปุ่มลูก 1 */}
      <OptionButton open={open} index={1} href="https://line.me/R/ti/p/@585ygnic" target="_blank">
        <span>พูดคุยผ่าน Funcrowd Care</span>
        <div className="circle">
          <img src={'/media/logos/funcrownd.jpg'} alt="LINE" />
        </div>
      </OptionButton>

      <OptionButton open={open} index={2} href="https://line.me/R/ti/p/@558vvvrr" target="_blank">
        <span>พูดคุยผ่าน Funcrowd Ai</span>
        <div className="circle">
          <img src={'/media/logos/funcrownd.jpg'} alt="Call" />
        </div>
      </OptionButton>

      {/* ปุ่มหลัก */}
      <MainButton onClick={() => setOpen(!open)}>
        <img src={open ? '/media/logos/close-button.png' : '/media/logos/funcrownd.jpg'} alt="Main" />
      </MainButton>
    </Wrapper>
  );
};

export default LineContactButton;

const pop = keyframes`
  from { transform: scale(0.5); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
`;

const Wrapper = styled.div`
  position: fixed;
  right: 16px;
  bottom: 96px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  z-index: 9999;
`;

const MainButton = styled.button`
  border: none;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.18);
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  padding: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 50%;
  }

  &:hover {
    transform: scale(1.12);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
    filter: brightness(1.05);
  }
`;

const OptionButton = styled.a`
  display: ${({ open }) => (open ? 'flex' : 'none')};
  align-items: center;
  position: relative;
  transform: ${({ open, index }) => (open ? `translateY(-${index * 70}px)` : 'none')};
  animation: ${pop} 0.25s ease forwards;

  span {
    background: #ffffff;
    padding: 8px 14px;
    border-radius: 20px;
    font-size: 14px;
    color: #333;
    margin-right: 10px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
    white-space: nowrap;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 50%; /* ตัดเป็นวงกลม */
  }

  &::after {
    content: '';
  }

  .circle {
    width: 48px;
    height: 48px;
    background: white;
    border-radius: 50%;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.18);
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      transform: scale(1.12);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
      filter: brightness(1.05);
    }
  }
`;
